import React from 'react';
import { bool, oneOf } from 'prop-types';
import { Translations } from 'modules';
import { FeatureFlags, Currency, Locale, SSRData, WishList } from 'contexts';
import productsCardsShape from 'shapes/productsCardsShape';
import translationsMap from '../../translations';
import { ProductCardsContainer } from './components';
import { getCorrectMainUrl } from './ProductsCards.utils';

// default data values to get things still work
import { ssrData } from './data';

const ALLOWED_PLATFORMS = ['fr', 'gb', 'es', 'it', 'de'];

function ProductsCards({
    platform,
    products,
    redesignedCard,
    withActionBlock,
}) {
    const { data, context } = ssrData;
    const { base_urls: baseUrls, ...otherData } = data;

    const cardsPlatform = platform || context.platform;
    baseUrls.main = getCorrectMainUrl({
        platform: cardsPlatform,
        rawUrl: baseUrls.main,
    });
    const placeholder = {
        ...otherData,
        base_urls: baseUrls,
        user: context.user,
        platform: cardsPlatform,
        environmentVariables: {},
    };

    return (
        <SSRData data={placeholder}>
            <FeatureFlags>
                <Translations
                    platform={cardsPlatform}
                    translations={translationsMap[cardsPlatform]}
                >
                    <WishList>
                        <Locale>
                            <Currency>
                                <ProductCardsContainer
                                    products={products}
                                    redesignedCard={redesignedCard}
                                    withActionBlock={withActionBlock}
                                />
                            </Currency>
                        </Locale>
                    </WishList>
                </Translations>
            </FeatureFlags>
        </SSRData>
    );
}

ProductsCards.propTypes = {
    products: productsCardsShape,
    redesignedCard: bool,
    withActionBlock: bool,
    platform: oneOf(ALLOWED_PLATFORMS).isRequired,
};

ProductsCards.defaultProps = {
    redesignedCard: false,
    withActionBlock: true,
    products: [],
};

export default ProductsCards;
